import React, { useState, useEffect } from "react";
import 'react-toastify/dist/ReactToastify.css';
import cx from "classnames";
import {CardTitle, Card} from "reactstrap";
import {useDropzone} from 'react-dropzone';
import Icon from "../../../components/Icon";
import FileUploadPreview from "../../../components/Model";
import requestApi from "../../../../../services/requestApi.service";
import {Modal, ModalHeader, ModalBody} from "reactstrap";
import {
	decodeString, getFieldValuefromComponent,
	getLicenseErrorStatus,
	getWpConnectionErrorStatus,
	handleErrorResponse,
	showToast,
	replaceVariables, replaceSymbolsToHtml, getProfileName, getSessionValue,
	loadCustomFormData,
	isMobile
} from "../../../../../Common/Appcommon";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import NoRecord from "../../../../../Common/NoRecord";
import { faCirclePlus, faMagnifyingGlass, faX, faPlus } from '@fortawesome/free-solid-svg-icons';

const attachButtons = [
	{ icon: "attachRooms", label: "Choose room" },
	//{ icon: "attachContacts", label: "Choose contact" },
	{ icon: "attachDocument", label: "Choose document" },
	//{ icon: "attachCamera", label: "Use camera" },
	{ icon: "attachImage", label: "Choose image" },
];

const ChatInput = ({
	showAttach,
	setShowAttach,
	showEmojis,
	setShowEmojis,
	newMessage,
	setNewMessage,
	submitNewMessage,
	submitNewMediaMessage,
	showTemplateModal,
	disableMsgSend,
	onChangeLeadUsage,
	user,
	quickreplyformname,
}) => {
	const [showModel, setShowModel] = useState(false);
	const [showLoader, setShowLoader] = useState(false);
	const [allAcceptedFiles, setallAcceptedFiles] = useState({});
	const [showQuickReply, setShowQuickReply] =useState(false);	//const attacheBtnRef = useRef(null);
	const [profileName, setProfileName] = useState('');
	const [quickReplySearch, setQuickReplySearch] = useState('');
	const [searchTxt, setSearchTxt] = useState([]);
	const [quickReplyTemplates, setQuickReplyTemplates] = useState([]);

	let apiError = false;
	let licenseError = false;
	let isWpConnectionError = getWpConnectionErrorStatus();
	let licenseErrorStatus = getSessionValue("licenseValidate");
	let blockedStatus = false;
	let optStatus = false;
	useEffect(() => {
		(async () => {
			let profile = await getProfileName();
			setProfileName(profile);
			await getQuickReplyTemplates();
		})();
	}, []);

	if(isWpConnectionError === 'true'){
		disableMsgSend = true;
		apiError = true;
	}else if(licenseErrorStatus[0] !== undefined && 
		licenseErrorStatus[0] === 1){
		disableMsgSend = true;
		licenseError = true;
	}
	if( user["wsapp_blocked"] == "Yes"){
		blockedStatus = true;
		disableMsgSend = true;
	}
	if(user["wsapp_opt"] =="No"){
		optStatus = true;
		disableMsgSend = true;
	}
	const {open} = useDropzone({
		// Disable click and keydown behavior
		noClick: true,
		noKeyboard: true,
		accept: {
			'image/*': ['.jpeg', '.png'],
			'video/*': ['.mp4', '.3gp'],
			'audio/*': ['.mp4', '.3gp'],
			'text/plain': [],
			'text/csv': [],
			'application/pdf': [],
			'application/vnd.ms-excel':[],
			'application/msword':[],
		},
		onDrop: (acceptedFiles,rejectedFiles) => {processSelectedFiles(acceptedFiles,rejectedFiles)},
		onFileDialogCancel:()=>{console.log("onFileDialogCancel invoked")},
		onFileDialogOpen:()=>{console.log("onFileDialogOpen invoked")},
		onError:(fileError)=>{console.log("Error Received",fileError)}
	  });
	// below is the same as componentDidMount and componentDidUnmount
	useEffect(() => {
		//console.log("useEffect called inside ChatInput component");
	  }, []);

	//   const handleClickOutside = event => {
	// 	if (attacheBtnRef.current && !attacheBtnRef.current.contains(event.target)) {
	// 		setShowAttach(false);
	// 	}
	//   };

	const toggleQuickReply = (status) => {
		setShowQuickReply(status);
		setQuickReplySearch('');
		setSearchTxt([]);
	}

	const detectEnterPress = (e) => {
		if ((e.key === "Enter" || e.keyCode === 13) && !e.shiftKey){
			let name = e.target.name;
			if(name === "inboxtext"){
				submitNewMessage();
			}else if(name === "quick-reply-search"){
				handleSearch("Name", quickReplySearch);
			}
			e.preventDefault()
		}
	};

	const detectSlashKeyPress = (e) => {
		if((e.key === "/" || e.keyCode === 191)){
			if(newMessage !== undefined && (newMessage.trim() === "/")){
				toggleQuickReply(true);
			}
		}
	};

	const openFileDialog = () => {
		open();
	};

	const processSelectedFiles = async (selectedFiles,rejectedFiles) => {
		const totalFiles=selectedFiles.length + Object.keys(allAcceptedFiles).length;
		if(totalFiles > 5){
			showToast("Maximum 5 files only allowed to upload!",'top-right','error');
			return;
		}
		const newUploads = selectedFiles.map(async (file,index) => {
			const fileType=file.type;
			const fileSize=file.size;

			if(fileType.includes("image/") && fileSize > 5*1000*1000){
				showToast("ERROR! file size should be less than 5MB",'top-right','error');
			}else if(fileType.includes("video/") && fileSize > 16*1000*1000){
				showToast("ERROR! file size should be less than 16MB",'top-right','error');
			}else if(fileType.includes("audio/") && fileSize > 16*1000*1000){
				showToast("ERROR! file size should be less than 16MB",'top-right','error');
			}else if((fileType.includes("text/") || fileType.includes("application/")) && fileSize > 100*1000*1000){
				showToast("ERROR! file size should be less than 100MB",'top-right','error');
			}else{
				setShowLoader(true);
				let params = {
					"ENTITY": "WHATSAPPPROCESS",
					"OPERATION": "FILE_UPLOAD",
					"file" : file,
					"isOtherApiReq" : true,
				}
				let response = await requestApi.processFileUpload(params);
				setShowLoader(false);
				if(response.issuccess){
					let uploadResponse = response.data;
					if(uploadResponse.status) {
						allAcceptedFiles[uploadResponse.mediaId] = {
							"name": uploadResponse.mediaName,
							"url": uploadResponse.mediaUrl,
							"type": uploadResponse.mediaType,

						};
					}
				} else {
					handleErrorResponse(response.errormsg);
				}
			}
					if(index === selectedFiles.length-1){
						if(Object.keys(allAcceptedFiles).length > 0){
							if(!showModel){
								setShowModel(!showModel);
							}
							setallAcceptedFiles({...allAcceptedFiles});
						}

			}
		});
	};

	const getQuickReplyTemplates = async (issearch=false) => {

		let templates = [];

		const { rowData } = await loadCustomFormData(
			issearch,
			quickreplyformname,
			{searchTxt : searchTxt, customCondition : 'Type#quick-reply'}
		);

		for(let i = 0; i < rowData.length ; i++){
			templates[i] = rowData[i]
		}

		setQuickReplyTemplates(templates);
	}

	const prepareMessageParams = async ( contactid, formname, components, message) => {
		let data = [];
		let params = {
			"ENTITY": "WHATSAPPPROCESS",
			"OPERATION": "PREPARE_MESSAGE_PARAMS",
			"contactid" : contactid,
			"FORMNAME" : formname,
			"components" : components,
			"message" : message,
			"isOtherApiReq" : true,
		}
        let responce = await requestApi.processServerRequest(params, "Mobile");
		if(responce.issuccess){
			data = responce.data;
		}

		return data;
	}

	const addTemplateMsg = async (e) => {

		let templateId = '';
		let message = "";
		let contactid = user['cid'];
		if(e.currentTarget !== undefined){
			templateId = e.currentTarget.getAttribute('data-id');
		}

		if(quickReplyTemplates[templateId] !== undefined){
			let components = quickReplyTemplates[templateId]['Components'] !== undefined ? 
					quickReplyTemplates[templateId]['Components'] : ''; 

			let formname = quickReplyTemplates[templateId]['formname'] !== undefined ?
			        quickReplyTemplates[templateId]['formname'] : '';

			message = quickReplyTemplates[templateId]['Message'] !== undefined ?
					quickReplyTemplates[templateId]['Message'] : '';

			message = decodeString(message,true);

			//Add component values into user data to perform actual lead info replace.
			// if(components !== undefined && components !== ""){
			// 	user = getFieldValuefromComponent(user, components);
			// }

			// Add component value based on multi form
			message = await prepareMessageParams(contactid, formname, components, message);

			//message = replaceVariables(user,message);
		}

		try{
			if(message !== ""){
				message = message.replace(/<br\s*\/?>/gm, '\n');
			}
		}catch(e){}

		setNewMessage(message);
		toggleQuickReply(false);
	}

	/*const processUploads=async (file,callback) => {
		const url = 'http://localhost/server/upload.php';
		const formData = new FormData();
		formData.append('file', file);
		const config = {
		  headers: {
			'Content-Type': 'multipart/form-data',
		  },
		};
		await axios.post(url, formData, config).then((response) => {
			callback(response);
		});
	  }*/

	const addQuickReply = () => {
		window.open("/#/settings/templates/quickreply", "_target");
	}

	const handleSearch = async (name, value) => {
		const pattern = /[!@#$%^&*()_+`=\-]/g;
		const containsSpecialCharacters = value.replace(pattern, '');
		setSearchTxt((prevSearchTxt) => ({
			...prevSearchTxt,
			[name]: containsSpecialCharacters,
		}));
	  };

	useEffect(() => {
		const fetchData = async () => {
			await getQuickReplyTemplates(true);
		};

		fetchData();
	}, [searchTxt]);
	


	const handleChangeSearch = async (e) => {
		let value = e.target.value;
		setQuickReplySearch(value);
		if(value === ""){
			handleSearch("Name", value);
		}
	}

	return (
		<div className={`chat__input-wrapper ${disableMsgSend ? 'chat__disable_msg' : ''}`}>
			<div className = {`chat_buttons`}>
			{ !disableMsgSend && showEmojis && (
				<button aria-label="Close emojis" onClick={() => setShowEmojis(false)}>
					<Icon id="cancel" className="chat__input-icon" />
				</button>
			)}
			{
				!disableMsgSend &&
				<button aria-label="Emojis" onClick={() => setShowEmojis(true)}>
					<Icon
						id="smiley"
						className={`chat__input-icon ${
							showEmojis ? "chat__input-icon--highlight" : ""
						}`}
					/>
				</button>

			}

			{/*{!disableMsgSend && showEmojis && (
				<>
					<button aria-label="Choose GIF">
						<Icon id="gif" className="chat__input-icon" />
					</button>
					<button aria-label="Choose sticker">
						<Icon id="sticker" className="chat__input-icon" />
					</button>
				</>
			)}*/}
			{ !disableMsgSend &&
			<div className="pos-rel">
				{/*<button aria-label="Attach" onClick={open} onClick1={() => setShowAttach(!showAttach)} ref={attacheBtnRef}> */}
				{ !isMobile() &&
				<button aria-label="Attach" onClick={open} disabled={disableMsgSend} className={cx("",{ 'disabled' : disableMsgSend})}>
					<Icon
						id="attach"
						className={`chat__input-icon ${
							showAttach ? "chat__input-icon--pressed" : ""
						}`}
					/>
				</button>
				}

				<div className={`chat__attach ${showAttach ? "chat__attach--active" : ""}`}>
					{attachButtons.map((btn) => (
						<button
							className="chat__attach-btn"
							aria-label={btn.label}
							key={btn.label}
						>
							<Icon id={btn.icon} className="chat__attach-icon" />
						</button>
					))}
				</div>
			</div>
			}
			{ !disableMsgSend &&
			<div>
				<button onClick={()=>toggleQuickReply(true)} aria-label="Quick Reply">
					<Icon
						id="quickreply"
						className="chat__input-icon"
					/>
				</button>
				<Modal size={"lg"} isOpen={showQuickReply} toggle={()=>toggleQuickReply(false)}>
					<ModalHeader className={`quickreply-inbox`} toggle={()=>toggleQuickReply(false)}>
						<div>
							<div className={`quickreply-inbox-header`}>
								<span>Quick Reply</span>
								<input
									type="text"
									name={`quick-reply-search`}
									title={"Special characters must not be used"}
									autoComplete="off"
									placeholder={"Search..."}
									className="le-form-field-input quick-reply-search-box"
									onChange={e => handleChangeSearch(e)}
									value={quickReplySearch}
									onKeyDown={detectEnterPress}
								/>
								<button onClick={() => handleSearch("Name", quickReplySearch)}>
									<FontAwesomeIcon className={`mr-1`} icon={faMagnifyingGlass}/>
								</button>
								{!isMobile() && 
									<div className={`quickreply-inbox-addbtn quick-replybtn-index ${ (profileName === 'Administrator' || profileName === 'super admin profile') ? '' : 'hide'}`}>
										<button onClick={(e) => addQuickReply()} className={cx("m-1 me-2 btn-icon le-button lePrimaryBtn quickreply-add")}>
											<FontAwesomeIcon className={`mr-1`} icon={faCirclePlus}/>
											{`Add Reply`}
										</button>
									</div>
								}
							</div>
						</div>
					</ModalHeader>
					<ModalBody >
						<div className="quickreply-box  quickreply-scrollbar">
							{
								quickReplyTemplates && quickReplyTemplates.length > 0 ?
								quickReplyTemplates.map(function(template,index){
									let name = template['Name'];
									let message = decodeString(template['Message'],true);
									try{
										message = message.replace(/\n/g, '<br>');
									}catch(e){}

									if(message !== undefined && message !== "" && message !== null){
										message = replaceSymbolsToHtml(message);
									}
									return (
										<>
											<div className={'quickreply-list-container'}>
												<div className="quickreply-header-title">/{name}</div>
												<div className="quickreply-body-data cursor-hover" data-id={index} onClick={addTemplateMsg}>
													<div className="quickreply-message">
														{message}
													</div>
												</div>
											</div>
										</>
									);
								}) : <NoRecord />
							}
						</div>
					</ModalBody>
				</Modal>
			</div>
			}
			</div>

			{ !disableMsgSend &&
				<textarea
					className={cx("chat__input form-control ci-max-height",{ 'disabled' : disableMsgSend})}
					placeholder="Type a message"
					name="inboxtext"
					value={newMessage}
					onChange={(e) => setNewMessage(e.target.value)}
					onKeyDown={detectEnterPress}
					onKeyUp={detectSlashKeyPress}
					disabled={disableMsgSend}
					rows={"5"}
				/>
			}
			{ !disableMsgSend && newMessage ? (
				<button aria-label="Send message" onClick={submitNewMessage}>
					<Icon id="send" className="chat__input-icon" />
				</button>
			) : <></> /*(
				<button aria-label="Record voice note">
					<Icon id="microphone" className="chat__input-icon" />
				</button>)*/ }
			{
				disableMsgSend &&
				<Card body className={`chat__disabled_content text-center`}>
					{
						apiError &&
						<>
							<CardTitle className={`chat__disabled_title`}>Action Required!</CardTitle>
							<span>It seems your WhatsApp Business API is not working. <a href={'/#/settings'} className={`header-notification-url`}>Click Here</a> to reconnect.</span>
						</>
					}
					{	licenseError &&
					<>
						<CardTitle className={`chat__disabled_title`}>Action Needed!</CardTitle>
						Your CRM account subscription has expired. Please subscribe to a plan to continue using your account
					</>
					}
					{	!apiError && !licenseError && !blockedStatus && !optStatus &&
							<>
								<CardTitle className={`chat__disabled_title`}>The customer has not spoken to you in the last 24 hours.</CardTitle>
								WhatsApp allows open chat for 24hrs after a user initiated response, beyond which you can only send approved templates or wait till the user initiates a message.
								<span className={`chat__showtemplate`} onClick={showTemplateModal} >Choose a template here</span>
							</>
					}
					{	blockedStatus  &&
						<>
							<CardTitle className={`chat__disabled_title`}>This Account was blocked</CardTitle>
								You want Unblock click this link
							<span className={`chat__showtemplate`} onClick={() => onChangeLeadUsage(user.cid)}>Unblock </span>
						</>
					}
					{	optStatus && 
						<>
							<CardTitle className={`chat__disabled_title`}>This Account was OptOut</CardTitle>
						</>
					}
				</Card>
			}

			{
				!disableMsgSend && false && <button aria-label="Template" onClick={showTemplateModal}>
					<Icon id="template" className="chat__input-icon br-none"/>
				</button>
			}
			{
				!disableMsgSend && <FileUploadPreview
					showModel={showModel}
					setShowModel={setShowModel}
					openFileDialog={openFileDialog}
					allAcceptedFiles={allAcceptedFiles}
					setallAcceptedFiles={setallAcceptedFiles}
					submitNewMediaMessage={submitNewMediaMessage}
					showLoader={showLoader}
				/>
			}
		</div>
	);
};

export default ChatInput;
